import { useEffect } from "react";
import { Compass, LockKeyhole, MessageCircle } from "lucide-react";
import BookingWidget from "@/components/BookingWidget";

function setMeta(selector, attribute, value) {
  const node = document.querySelector(selector);
  if (node) {
    node.setAttribute(attribute, value);
  }
}

export default function TripPlannerPage() {
  useEffect(() => {
    document.title = "BlackRide | Private Trip Planner";
    setMeta('meta[name="description"]', "content", "Private BlackRide trip planning page used for internal quote preparation and route design.");
    setMeta('meta[name="robots"]', "content", "noindex, nofollow");
    setMeta('link[rel="canonical"]', "href", "https://getblackride.com/trip-planner");
    return () => {
      setMeta('meta[name="robots"]', "content", "index, follow");
    };
  }, []);

  return (
    <main className="min-h-screen bg-[#050505] text-white">
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-[0.88fr_1.12fr] gap-10 items-start">
          <div className="rounded-[32px] border border-white/10 bg-[linear-gradient(180deg,#141414,#0a0a0a)] p-8 md:p-10 shadow-[0_30px_80px_rgba(0,0,0,0.28)]">
            <div className="w-14 h-14 rounded-2xl bg-[#C7A239]/10 flex items-center justify-center mb-6">
              <Compass className="h-7 w-7 text-[#C7A239]" />
            </div>
            <p className="text-xs uppercase tracking-[0.32em] text-[#C7A239] mb-4">Private planner</p>
            <h1 className="font-[Playfair_Display] text-4xl md:text-5xl leading-tight text-white mb-4">Internal route and quote planner</h1>
            <p className="text-base text-gray-400 leading-relaxed mb-8">
              This page remains available for internal trip design, route checks, and operational planning while the public launch is handled through WhatsApp-first concierge bookings.
            </p>
            <div className="space-y-4">
              <div className="rounded-[24px] border border-white/10 bg-white/[0.03] p-5">
                <div className="flex items-center gap-3 text-white font-medium mb-2">
                  <MessageCircle className="h-5 w-5 text-[#25D366]" />
                  Concierge-led confirmation
                </div>
                <p className="text-sm text-gray-400 leading-relaxed">Guests should still confirm quotations and final trip details directly on WhatsApp during the initial rollout.</p>
              </div>
              <div className="rounded-[24px] border border-white/10 bg-white/[0.03] p-5">
                <div className="flex items-center gap-3 text-white font-medium mb-2">
                  <LockKeyhole className="h-5 w-5 text-[#C7A239]" />
                  Not linked from public navigation
                </div>
                <p className="text-sm text-gray-400 leading-relaxed">This page is intentionally not linked from the landing page header, hero, or mobile CTA while the consumer launch is being rolled out carefully.</p>
              </div>
            </div>
          </div>

          <div className="rounded-[32px] border border-white/10 bg-[linear-gradient(180deg,rgba(20,20,20,0.92),rgba(7,7,7,0.92))] p-4 md:p-6 shadow-[0_30px_80px_rgba(0,0,0,0.28)]">
            <BookingWidget />
          </div>
        </div>
      </section>
    </main>
  );
}
